module.exports = __webpack_public_path__ + "static/img/P3.519f540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hjzs/P3.png
// module id = /CIL
// module chunks = 0